import { MEDIA_HM_PATH, ProductFront } from "@project/shared-types";
import React from "react";
import { Button } from "../../../components/button/button";
import { Link } from "../../../components/link/link";
import { Label } from "../../../components/texts/label";
import { Text } from "../../../components/texts/text";
import { _colorText, _size, _sizeText, _typeLabel } from "../../../core/core";
import "./ServiceCard.css";

interface ServiceProps {
  service: ProductFront;
  className?: string;
}

export const ServiceView: React.FC<ServiceProps> = ({ service, className = "services-item", ...props }) => {
  return (
    <Link
      link={`/uslugi/${service.service_url}`}
      is_block
      key={service.id}
      className={className}
      {...props}
    >
      <div className="card-service-h">
        <div className="card-service-hr">
          <Text size={_sizeText.s}>{service.new_place_name}</Text>
          <Text size={_sizeText.xlb}>{service.new_name}</Text>
        </div>
        {service.place && (
          <img
            height="40px"
            width="40px"
            src={`${MEDIA_HM_PATH}${service.icon}`}
            alt={`иконка svg ${service.new_place_name}`}
          />
        )}
      </div>
      <Label type={_typeLabel.neutral}>{service.new_desc_2}</Label>
      <div className="card-service-f">
        <Text color={_colorText.black} size={_sizeText.xlb}>
          от {service.new_min_price} ₽/шт
        </Text>
        <Button
          width="100%"
          size={_size.M}
          onClick={() => {
            if (typeof window !== "undefined") {
              window.location.href = `/uslugi/${service.service_url}`;
            }
          }}
        >
          Заказать
        </Button>
      </div>
    </Link>
  );
};
